import { errorsInterceptor } from './errors-interceptor.service';

export default angular
  .module('sfMobile.services.errors', [])
  .factory('errorsInterceptor', errorsInterceptor).name;
